import { marked } from "marked";

// Match the existing markdown rendering behavior used in
// `admin-panel/src/pages/Reports/report.jsx`:
// - A trailing "\" means "hard line break"
// - Single newlines render as line breaks
export function normalizeMarkdownLikeText(text) {
  // Some sources deliver newlines as the two-character sequence "\n"
  // (e.g. JSON-encoded strings or logs). Convert those into real newlines first.
  const raw = String(text ?? "").replaceAll("\\r\\n", "\n").replaceAll("\\n", "\n");
  // 1) Support the common "markdown hard break" convention used in our prompts:
  //    A trailing "\" indicates an intended line break.
  //
  // 2) In some JS string contexts (e.g. constants files), a trailing "\" can
  //    *escape the newline*, collapsing lines at runtime. As a safety net,
  //    we also treat "\" followed by the next line's typical starters as a break.
  //
  // This keeps behavior aligned with the admin-panel markdown viewer.
  const withSyntheticBreaks = raw.replace(
    /\\\s*(?=(\*\*|###|\d+\.\s|-\s|\*\s))/g,
    "  \n"
  );

  return withSyntheticBreaks.replace(/\\\s*$/gm, "").replace(/\r?\n/g, "  \n");
}

export function parseToHTML(text) {
  marked.setOptions({ gfm: true, breaks: true });
  return marked.parse(normalizeMarkdownLikeText(text));
}

